export default "__VITE_ASSET__DFZQlpA9__"